/*
 * @Author: zhoulang zhoulang@kuaishou.com
 * @Date: 2024-05-09 10:19:35
 * @LastEditors: zhoulang zhoulang@kuaishou.com
 * @LastEditTime: 2024-05-24 16:39:42
 * @FilePath: /kibt-fe-shop-c-krn/src/common/utils/checkMediaSource.ts
 * @Description: 对进入到商详页和提单页的跳转链接进行校验，如果mediasource和mediaid不合法，上报自定义埋点到雷达
 */
import { getPageProps } from '@kibt/krn-utils';
import queryString from 'query-string';
import { radar } from '../log';
import { getEnv } from '../api';
import { BUNDLE_ID_LIST } from '../const';

type TExtParams = {
    cId?: string;
    cT?: string;
    cS?: string;
};

export const checkMediaSource = jumpUrl => {
    try {
        if (getEnv() !== 'prod') {
            return;
        }

        const currentBundleId = getPageProps().bundleId;

        const parseJumpUrl = () => {
            const parseUrl = queryString.parseUrl(jumpUrl);

            const redirectUrl = parseUrl.query.redirectUrl;
            const redirectUrlObj = queryString.parse(redirectUrl as string);
            const bundleId = redirectUrlObj.bundleId as string;

            const extParams = parseUrl.query.extParams as string;
            let parseExtParams = {} as TExtParams;
            try {
                parseExtParams = JSON.parse(extParams);
            } catch (e) {
                console.log('parseExtParams error =>', e);
            }

            return {
                bundleId,
                extParams: parseExtParams,
            };
        };

        const { bundleId: nextBundleId, extParams } = parseJumpUrl();

        const isJumpToDetailOrOrderConfirm = ['Detail', 'EcommOrderConfirm'].includes(nextBundleId);
        // console.log(isJumpToDetailOrOrderConfirm, currentBundleId, extParams, 'extParams====');
        // 短视频进商详、提单，cT值必须是1或者12（1是主卡，12是推荐双列），cId值必须15位
        if (isJumpToDetailOrOrderConfirm && currentBundleId === 'EcomRecommendGoods') {
            if (![1, 12, 51].includes(+extParams?.cT)) {
                // console.log('extParams==== null');
                radar.event({
                    name: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    eventType: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }

            if ([1, 12, 51].includes(+extParams?.cT) && extParams?.cId?.toString()?.length !== 15) {
                // console.log('extParams==== error');
                radar.event({
                    name: 'CUSTOM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_MEDIA_ID_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }

        // 直播间进商详、提单，cT值必须是0，cId值必须9位
        if (isJumpToDetailOrOrderConfirm && currentBundleId === 'ShoppingCar') {
            if (![0, '0'].includes(extParams?.cT)) {
                // console.log('extParams==== null');
                radar.event({
                    name: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    eventType: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }

            if ([0, '0'].includes(extParams?.cT) && extParams?.cId?.toString()?.length !== 9) {
                // console.log('extParams==== error');
                radar.event({
                    name: 'CUSTOM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_MEDIA_ID_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }

        // 店铺页进商详、提单，cT值必须是4或者10，cId值必须5-7位
        if (isJumpToDetailOrOrderConfirm && [BUNDLE_ID_LIST.ExpEcommMerchant, BUNDLE_ID_LIST.EcommMerchant].includes(currentBundleId)) {
            if (![4, 10].includes(+extParams?.cT)) {
                radar.event({
                    name: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    eventType: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }

            if ([4, 10].includes(+extParams?.cT) && !(extParams?.cId?.toString()?.length <= 7 && extParams?.cId?.toString()?.length >= 5)) {
                radar.event({
                    name: 'CUSTOM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_MEDIA_ID_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }

        // 商详店铺推荐、商详页凑单跳转到商详
        if (isJumpToDetailOrOrderConfirm && currentBundleId === 'Detail') {
            // if (![5, 30, 49, 61].includes(+extParams?.cT)) {
            //     radar.event({
            //         name: 'CUSTOM_MEDIA_SOURCE_ERROR',
            //         eventType: 'CUSTOM_MEDIA_SOURCE_ERROR',
            //         params: {
            //             currentBundleId,
            //             nextBundleId,
            //             jumpUrl,
            //         },
            //     });
            //     return;
            // }

            if ([5, 30, 49, 61].includes(+extParams?.cT) && !extParams?.cId) {
                radar.event({
                    name: 'CUSTOM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_MEDIA_ID_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }

        // 订单详情、订单详情猜喜跳转到商详
        if (isJumpToDetailOrOrderConfirm && currentBundleId === 'OrderDetail') {
            if (![9, 23].includes(+extParams?.cT)) {
                radar.event({
                    name: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    eventType: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }

            if ([9].includes(+extParams?.cT) && !extParams?.cId) {
                radar.event({
                    name: 'CUSTOM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_MEDIA_ID_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }

        // P页跳转到商详
        if (isJumpToDetailOrOrderConfirm && currentBundleId === 'EcommProfile') {
            if (+extParams?.cT !== 11) {
                radar.event({
                    name: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    eventType: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }

            if (+extParams?.cT === 11 && !extParams?.cId) {
                radar.event({
                    name: 'CUSTOM_MEDIA_ID_ERROR',
                    eventType: 'CUSTOM_MEDIA_ID_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }

        // 购物车、购物车猜喜模块、购物车顺手买一件、购物车凑单跳转到商详
        if (isJumpToDetailOrOrderConfirm && currentBundleId === 'MyShoppingCar') {
            if (![21, 24, 36, 48].includes(+extParams?.cT)) {
                radar.event({
                    name: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    eventType: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }

        // 评价页跳转商详
        if (isJumpToDetailOrOrderConfirm && currentBundleId === 'EcommAddComment') {
            if (![52, 53, 54].includes(+extParams?.cT)) {
                radar.event({
                    name: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    eventType: 'CUSTOM_MEDIA_SOURCE_ERROR',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }

        if (isJumpToDetailOrOrderConfirm) {
            if (![0, '0'].includes(extParams?.cT) && !extParams?.cT) {
                radar.event({
                    name: 'CUSTOM_MEDIA_SOURCE_NUll',
                    eventType: 'CUSTOM_MEDIA_SOURCE_NUll',
                    params: {
                        currentBundleId,
                        nextBundleId,
                        jumpUrl,
                    },
                });
            }
        }
    } catch (error) {
        console.log(error);
    }
};
